<app-product-template *ngIf="productTemplate" [productTemplate]="productTemplate"></app-product-template>
<app-alert-error *ngIf="!productTemplate && error" [error]="error"></app-alert-error>